import { render, staticRenderFns } from "./CameraCollectionImg.vue?vue&type=template&id=1db4c91e&scoped=true&"
import script from "./CameraCollectionImg.vue?vue&type=script&lang=js&"
export * from "./CameraCollectionImg.vue?vue&type=script&lang=js&"
import style0 from "./CameraCollectionImg.vue?vue&type=style&index=0&id=1db4c91e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4c91e",
  null
  
)

export default component.exports